import { render, staticRenderFns } from "./InstafreshDashboard.vue?vue&type=template&id=10ed5715"
import script from "./InstafreshDashboard.vue?vue&type=script&lang=ts"
export * from "./InstafreshDashboard.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports